import NextLink from 'next/link';
import useHelpers from 'hooks/helpers';
import { UTCFormat } from '@/constants/dateFormats';
import NextImage from 'next/image';
import Readtime from 'components/includes/Readtime';
import styles from './ArticleCardHorizontal.module.scss';

const ArticleCardHorizontal = ({ data }) => {
  const { localizeDate } = useHelpers();
  const getDate = localizeDate(data.articlePublicationDate.formattedDateValue, UTCFormat);
  const url = `${data.baseUrl}/${data?.name.toLowerCase().replaceAll(' ', '-')}`;
  return (
    <NextLink href={url} className={styles['article-card']} prefetch={false}>
      <div className="d-flex flex-column flex-md-row gap-4">
        <div className="flex-shrink-0">
          <NextImage
            src={data.articleImage}
            alt={data.articleImageAlt}
            className={styles['article-card__image']}
            width={200}
            height={170}
          />
        </div>
        <div className="d-flex flex-column flex-grow-1">
          <div className="d-flex justify-content-between gap-2">
            <div className="section-header-small">{data.tag}</div>
            <time className="section-header-small text-nowrap">{getDate}</time>
          </div>

          <h4 className={`${styles['article-card__title']} h4 mt-2 mb-3`}>{data.name}</h4>

          <div className="mt-auto">
            <Readtime
              articleType={data.articleType}
              duration={data.duration.value}
              className="section-header-small"
            />
          </div>
        </div>
      </div>
    </NextLink>
  );
};

export default ArticleCardHorizontal;
